import { Nbsp } from '@/components/nbsp';
import { Button, Badge } from '@simplywallst/ui-core/next';

interface Props {
  populatedRowCount: number;
  incompleteRowCount: number;
  disabled?: boolean;
  onSave: () => void;
  onDiscard: () => void;
}

export const Footer = ({
  populatedRowCount,
  incompleteRowCount,
  disabled = false,
  onSave,
  onDiscard,
}: Props) => {
  const status = `${
    populatedRowCount - incompleteRowCount
  }/${populatedRowCount} transactions ready`;

  return (
    <div className="grid grid-cols-[minmax(auto,_1200px)] justify-center items-center bg-surface-1">
      <div className="grid grid-cols-[max-content_max-content] justify-between items-center px-x2">
        <Button variant="secondary" onClick={onDiscard} isDisabled>
          Discard and go back
        </Button>
        <div className="grid grid-cols-[max-content_max-content] justify-end items-center gap-x2">
          <Badge className="text-xs text-solid px-x1_75">
            <span role="status" aria-label={status}>
              <strong>
                {`${
                  populatedRowCount - incompleteRowCount
                } / ${populatedRowCount}`}
              </strong>
              <Nbsp />
              <Nbsp />
              <span className="text-soft">transactions ready</span>
            </span>
          </Badge>
          <Button
            variant="primary"
            className="min-w-[100px]"
            isDisabled={disabled}
            onClick={onSave}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};
